/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:556b71f6-c66d-489c-b21c-e215b4aebf91",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_Y4znyOwlO",
    "aws_user_pools_web_client_id": "67og56e672p39lkd3mm80pgq61",
    "oauth": {
        "domain": "spotsaverec123cb5-ec123cb5-main.auth.us-east-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "http://localhost:8080/",
        "redirectSignOut": "http://localhost:8080/",
        "responseType": "code",
        "facebookAppId": "440527097542016",
        "googleClientId": "118519439854-mk5f8es8abt527jkcf8626bobib9i2ig.apps.googleusercontent.com",
        "facebookAppIdUserPool": "440527097542016",
        "facebookAppSecretUserPool": "14bc478c190b688b9af0ea59b3a163b7",
        "googleAppIdUserPool": "118519439854-mk5f8es8abt527jkcf8626bobib9i2ig.apps.googleusercontent.com",
        "googleAppSecretUserPool": "lMZ5pbnUwz9QO_BVgmlCK81N"
    },
    "federationTarget": "COGNITO_USER_AND_IDENTITY_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [
        "FACEBOOK",
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "spotsavermain50228-main",
    "aws_user_files_s3_bucket_region": "us-east-2",
    "aws_appsync_graphqlEndpoint": "https://prkrq6taivcj7eajiahbsjnnia.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "facebookAppId": "440527097542016",
    "googleClientId": "118519439854-mk5f8es8abt527jkcf8626bobib9i2ig.apps.googleusercontent.com",
    "facebookAppIdUserPool": "440527097542016",
    "facebookAppSecretUserPool": "14bc478c190b688b9af0ea59b3a163b7",
    "googleAppIdUserPool": "118519439854-mk5f8es8abt527jkcf8626bobib9i2ig.apps.googleusercontent.com",
    "googleAppSecretUserPool": "lMZ5pbnUwz9QO_BVgmlCK81N",
    "aws_cognito_login_mechanisms": [
        "EMAIL",
        "PHONE_NUMBER",
        "FACEBOOK",
        "GOOGLE"
    ]
};


export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js